import { getAdmin, newAdmin, deleteAdmin, logOff } from '@/api/api.js';
import { configuration } from '@/api/aws-exports';
import AWS from 'aws-sdk';
import { Auth } from 'aws-amplify';
import { log } from '@/constants.js';
import router from '@/router';

// Cognito access/ID tokens default to a 60 minute lifetime: refresh well before
// that, and also on tab focus, since a backgrounded/suspended tab can miss ticks.
const REFRESH_INTERVAL_MS = 30 * 60 * 1000;
let refreshIntervalId = null;
let onVisibilityChange = null;

export const state = {
  headers: [
    {
      text: 'Username',
      align: 'start',
      sortable: true,
      value: 'username'
    },
    { text: 'Name', value: '_name' },
    { text: 'Surname', value: 'surname' },
    { text: 'Email', value: 'email' },
    { text: 'Actions', value: 'actions', sortable: false, width: 130 }
  ],
  admins: [],
  editAdmin: false
};

export const mutations = {
  EDIT_ADMIN_CHANGED(state, edit) {
    state.editAdmin = edit;
  },
  GET_ADMIN(state, AdminArray) {
    state.admins = AdminArray;
  },
  NEW_ADMIN(state, adminToAdd) {
    state.admins.push(adminToAdd.data.createAdminUser);
  },
  DELETE_ADMIN(state, delete_username) {
    state.admins.forEach(element => {
      if (element.username == delete_username) {
        const index = state.admins.indexOf(element);
        state.admins.splice(index, 1);
      }
    });
  }
};

export const actions = {
  changeEditAdmin({ commit }, edit) {
    commit('EDIT_ADMIN_CHANGED', edit);
  },

  async storeAdmins({ dispatch, commit }) {
    try {
      const admin = await getAdmin();
      commit('GET_ADMIN', admin.data.listAdmin);
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'storeAdmins',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  },

  async storeNewAdmin({ commit, dispatch }, admin) {
    try {
      const adminToAdd = await newAdmin(
        admin.username,
        admin._name,
        admin.surname,
        admin.email
      );
      dispatch(
        'storeToastMessage',
        {
          text: 'admin created',
          type: 'success'
        },
        { root: true }
      );
      commit('NEW_ADMIN', adminToAdd);
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'storeNewAdmin',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  },

  async deleteTableAdmin({ dispatch, commit, rootState }, username) {
    try {
      dispatch(
        'storeToastMessage',
        {
          text: 'start to delete admin',
          type: 'info'
        },
        { root: true }
      );
      const adminToDelete = await deleteAdmin(username);
      dispatch(
        'storeToastMessage',
        {
          text: 'admin deleted',
          type: 'success'
        },
        { root: true }
      );
      commit('DELETE_ADMIN', adminToDelete.data.deleteAdminUser.username);

      if (username === rootState.username) {
        await logOff();
        router.push('/');
        location.reload();
      }
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'deleteTableAdmin',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  },
  async setCredentials({ dispatch }) {
    try {
      const session = await Auth.currentSession();
      AWS.config.region = configuration.aws_project_region;
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: configuration.aws_cognito_identity_pool_id,
        Logins: {
          [`cognito-idp.${configuration.aws_project_region}.amazonaws.com/${configuration.Auth.userPoolId}`]: session
            .getIdToken()
            .getJwtToken()
        }
      });
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'setCredentials',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  },
  async refreshToken({ dispatch }) {
    if (refreshIntervalId) {
      clearInterval(refreshIntervalId);
    }

    if (onVisibilityChange) {
      document.removeEventListener('visibilitychange', onVisibilityChange);
    }

    const doRefresh = async () => {
      try {
        const session = await Auth.currentSession();
        const refresh_token = session.getRefreshToken();
        const cognitoUser = await Auth.currentAuthenticatedUser();

        await new Promise((resolve, reject) => {
          cognitoUser.refreshSession(refresh_token, (err, refreshedSession) => {
            if (err) {
              reject(err);

              return;
            }

            if (AWS.config.credentials) {
              AWS.config.credentials.params.Logins[
                `cognito-idp.${configuration.aws_project_region}.amazonaws.com/${configuration.Auth.userPoolId}`
              ] = refreshedSession.getIdToken().getJwtToken();
              AWS.config.credentials.refresh(refreshErr =>
                refreshErr ? reject(refreshErr) : resolve()
              );
            } else {
              resolve();
            }
          });
        });

        log.info('TOKEN SUCCESSFULLY UPDATED');
      } catch (err) {
        clearInterval(refreshIntervalId);
        refreshIntervalId = null;
        document.removeEventListener('visibilitychange', onVisibilityChange);
        onVisibilityChange = null;

        dispatch(
          'storeToastMessage',
          {
            text: 'Sessione scaduta, effettua nuovamente il login',
            errObj: err,
            type: 'danger'
          },
          { root: true }
        );
        await logOff();
        router.push('/');
        location.reload();
      }
    };

    onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        doRefresh();
      }
    };

    document.addEventListener('visibilitychange', onVisibilityChange);
    refreshIntervalId = setInterval(doRefresh, REFRESH_INTERVAL_MS);
  }
};

export const getters = {};
